import React from "react";
import T from "prop-types";
import {
  CANCELLATION_REASONS,
  SEND_CANCELLATION_EMAIL
} from "MODULES/SalesOrders/constants";
import { Modal, Header, Body, Close } from "MODULES/shared/components/Modal";
import { Field, FieldArray } from "redux-form";
import { CANCELLATION_REASON } from "MODULES/PurchaseOrders/constants";
import {
  Check,
  CheckGroup,
  Select,
  form,
  Form as AppForm,
  CurrencyField
} from "MODULES/shared/components/Forms";
import { properCase } from "LIB/formatters/text";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { cancel } from "MODULES/SalesOrders/actions";
import { SRP_CONDITION, SUGGESTED_RETAIL } from "MODULES/inventories/constants";
import { Warning } from "MODULES/shared/components";
import { SRP_CONDITION_OPTIONS } from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/Form";
import validate from "./validate";

function LineItems({ lineItems, fields }) {
  return (
    <tbody>
      {fields.map((item, idx) => {
        const lineItem = lineItems[idx];

        return (
          <tr key={`item-${lineItem.id}`}>
            <td
              className="text-right"
              style={{ verticalAlign: "top", paddingTop: 8, paddingLeft: 10 }}
            >
              {idx + 1}
            </td>
            <td>
              <Row>
                <Col md={4}>
                  <span className="float-left">
                    {lineItem.part.part_number} |&nbsp;
                    {lineItem.serial_number}
                  </span>
                </Col>
                <Col md={4}>
                  <CurrencyField
                    name={`${item}.inventory.${SUGGESTED_RETAIL}`}
                    label="SRP"
                    required
                  />
                </Col>
                <Col md={4}>
                  <Field
                    name={`${item}.inventory.${SRP_CONDITION}`}
                    component={Select}
                    options={SRP_CONDITION_OPTIONS}
                    label="SRP Condition"
                    required
                  />
                </Col>
              </Row>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
}

export function Reason({ visible, close, salesOrder, ...props }) {
  return (
    <Modal open={visible} close={close} dialogClass="modal-md">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Are You Sure?</h4>
      </Header>
      <Body>
        <AppForm {...props} close={close}>
          <AppForm.Body>
            <Warning>
              <strong>Heads up!</strong>
              &nbsp;Cancelling a SO will cancel all line items associated with
              it.
              <Row className="row-col-gutters-half">
                <Col md={12}>
                  <Field
                    name={CANCELLATION_REASON}
                    className="text-right"
                    component={Select}
                    options={CANCELLATION_REASONS}
                    prompt={false}
                    label={properCase(CANCELLATION_REASON)}
                  />
                </Col>
              </Row>
            </Warning>
            <h4>Parts</h4>
            <Row className="row-col-gutters-half">
              <Col md={12}>
                <table className="table table-striped table-numbered margin-bottom-none">
                  <FieldArray
                    name="line_items"
                    component={LineItems}
                    lineItems={salesOrder.line_items}
                  />
                </table>
              </Col>
            </Row>
            <div>
              <br />
              <CheckGroup title="Send Customer Cancellation Email">
                <Field
                  name={SEND_CANCELLATION_EMAIL}
                  component={Check}
                  label={properCase(SEND_CANCELLATION_EMAIL)}
                />
              </CheckGroup>
            </div>
          </AppForm.Body>
        </AppForm>
      </Body>
    </Modal>
  );
}

Reason.propTypes = {
  visible: T.bool.isRequired,
  close: T.func.isRequired,
  cancel: T.func.isRequired,
  reason: T.string.isRequired,
  updateReason: T.func.isRequired,
  updateEmail: T.func.isRequired
};

const FORM_NAME = "cancelSalesOrder";

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(cancel(ownProps.salesOrder.id, data, ownProps.close))
}))(
  form({
    form: FORM_NAME,
    validate
  })(Reason)
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/Cancel/Reason.jsx